/**
 *
 */
export class SchemaMetaData {
    public version?: "v1";
    public type?: "jobTemplate"|"job";
}
